<template>
    <div>
        <h1>
            Comptadors
            <b-button size="sm" class="mr-2" v-on:click="download">
                <span>Descarregar Lectures&nbsp;<font-awesome-icon icon="download"/></span>
            </b-button>
        </h1>


        <b-table
                striped
                hover
                small
                responsive
                stacked="sm"
                :busy="this.$store.state.loadingPanels"
                v-bind:fields="fields"
                v-bind:items="rows"
        >
            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"/>
                <strong>&nbsp; Carregant dades...</strong>
            </div>

            <template slot="showDetails" slot-scope="row">
                <b-button v-if="row.item.showDetails" size="sm" @click="row.toggleDetails" class="mr-2">
                    <span><font-awesome-icon icon="info"/></span>
                </b-button>
            </template>

            <template slot="row-details" slot-scope="row">
                <b-card>
                    <table class="table table-borderless">
                        <tbody>
                        <tr v-if="row.item.reading.status_code === 'error'">
                            <td class="danger-cell">Error</td>
                            <td class="base-cell message-cell">{{ row.item.reading.status_message }}</td>
                        </tr>
                        <tr v-if="row.item.reading.status_code === 'error'">
                            <td class="danger-cell">Error</td>
                            <td class="base-cell message-cell">{{ row.item.reading.status_message }}</td>
                        </tr>
                        <tr v-if="row.item.reading.status_code === 'warning'">
                            <td class="warning-cell">Alerta</td>
                            <td class="base-cell message-cell">{{ row.item.reading.status_message }}</td>
                        </tr>
                        <tr v-if="row.item.reading.status_code === 'warning'">
                            <td class="warning-cell">Alerta</td>
                            <td class="base-cell message-cell">{{ row.item.reading.status_message }}</td>
                        </tr>
                        </tbody>
                        <tr v-for="validation in row.item.reading.validations">
                            <td v-if="validation.type === 'alarm'" class="danger-cell">Alarma</td>
                            <td v-if="validation.type === 'alert'" class="warning-cell">Alerta</td>
                            <td v-if="validation.type === 'info'" class="validation-cell">Info</td>
                            <td class="base-cell message-cell">{{ validation.message }}</td>
                        </tr>
                    </table>
                </b-card>
            </template>
        </b-table>
    </div>
</template>

<style scoped>
    .danger-cell {
        background-color: #f5c6cb;
    }

    .warning-cell {
        background-color: #ffeeba;
    }

    .validation-cell {
        background-color: #bee5eb;
    }

    .message-cell {
        text-align: left;
    }

    .base-cell {
        background-color: white;
    }
</style>

<style>
    .align-left {
        text-align: left;
    }
</style>

<script>
    import Api from "../api"
    import router from '../router'

    export default {
        name: "CountersView",
        data: function () {
            return {
                counters: []
            }
        },
        methods: {
            loadCounters() {
                this.counters = []
                this.$store.commit('setLoadingPanels', true)
                Api.counters().then(response => {
                    this.counters = response.data.data
                }).catch(error => {
                    if (error.response && error.response.status === 401) {
                        //Unauthorized:
                        router.push('/login')
                    }
                }).finally(() => {
                    this.$store.commit('setLoadingPanels', false)
                })
            },
            download() {
                Api.countersDownload()
                    .then(({data}) => {
                        let blob = new Blob([data], {type: data.type})
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = 'LecturesComptadors.xlsx'
                        link.click()
                    })
                    .catch(({error}) => {
                        window.console.log(error)
                    })
            }
        },
        mounted() {
            this.loadCounters()
        },
        computed: {
            fields() {
                return {
                    counter: {
                        label: 'Comptador',
                        sortable: true
                    },
                    owner: {
                        label: 'Propietari',
                        sortable: true,
                        tdClass: 'align-left'
                    },
                    panels: {
                        label: 'Seguidors',
                        sortable: false,
                        tdClass: 'align-left'
                    },
                    imported: {
                        label: 'Total Importat',
                        sortable: true
                    },
                    exported: {
                        label: 'Total Exportat',
                        sortable: true
                    },
                    registeredAt: {
                        label: 'Última lectura',
                        sortable: true
                    },
                    showDetails: {
                        label: 'Detalls'
                    }
                }
            },
            rows() {
                //Apply styling for warnigs and other possible item related information to display on table:
                let rows = []
                this.counters.forEach(counter => {
                    let row = {
                        counter: counter.name,
                        owner: '',
                        panels: '',
                        imported: null,
                        exported: null,
                        registeredAt: null,
                        reading: null,
                        showDetails: false,
                        _cellVariants: {}
                    }

                    counter.panels.forEach(code => {
                        row.panels += code + ', '
                    })
                    if (row.panels.length > 0) {
                        row.panels = row.panels.substr(0, row.panels.length - 2)
                    }

                    if (counter.owner !== null) {
                        row.owner = counter.owner.name
                    }

                    if (counter.last_reading !== null) {
                        row.reading = counter.last_reading
                        row.imported = counter.last_reading.total_imported
                        row.exported = counter.last_reading.total_exported
                        row.registeredAt = counter.last_reading.registered_at
                        row.showDetails = true

                        let variantDefined = false
                        if (row.reading.status_code === 'warning') {
                            row._cellVariants.imported = 'warning'
                            row._cellVariants.exported = 'warning'
                            variantDefined = true
                        }

                        if (row.reading.status_code === 'error') {
                            row._cellVariants.imported = 'danger'
                            row._cellVariants.exported = 'danger'
                            variantDefined = true
                        }

                        if (row.reading.validations.length > 0 && !variantDefined) {
                            let alerts = 0
                            let alarms = 0
                            row.reading.validations.forEach(function (validation) {
                                if (validation.type === 'alarm') {
                                    alarms++
                                }
                                if (validation.type === 'alert') {
                                    alerts++
                                }
                            })
                            if (alarms > 0) {
                                row._cellVariants.imported = 'danger'
                                row._cellVariants.exported = 'danger'
                            } else if (alerts > 0) {
                                row._cellVariants.imported = 'warning'
                                row._cellVariants.exported = 'warning'
                            } else {
                                row._cellVariants.imported = 'info'
                                row._cellVariants.exported = 'info'
                            }
                        }
                    }

                    rows.push(row)
                })
                return rows
            }
        }
    }

</script>

<style scoped>

</style>